import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'login' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'login' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'profile-settings',
        path: 'profile-settings',
        component: () => import('../pages/settings/ProfileSetting.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'roles',
        path: 'roles',
        component: () => import('../pages/users/RolesPage.vue'),
      },
      {
        name: 'staffs',
        path: 'staffs',
        component: () => import('../pages/staffs/Staffs.vue'),
      },
      {
        name: 'invoices',
        path: 'invoices',
        children: [
          {
            name: 'invoices-list',
            path: 'invoices-list',
            component: () => import('../pages/invoices/InvoicesPage.vue'),
          },
          {
            name: 'view-invoice',
            path: 'view/:id',
            component: () => import('../pages/invoices/InvoicePage.vue'),
          },
          {
            name: 'new-invoice',
            path: 'new',
            component: () => import('../pages/invoices/NewInvoicePage.vue'),
          },
        ],
      },
      {
        name: 'payroll',
        path: 'payroll',
        children: [
          {
            name: 'employees',
            path: 'employees',
            component: () => import('../pages/payroll/Employee.vue'),
          },
          {
            name: 'view-employee',
            path: 'employee-view/:id',
            component: () => import('../pages/payroll/ViewEmployee.vue'),
          },
          {
            name: 'payroll-items',
            path: 'payroll-items',
            component: () => import('../pages/payroll/PayrollItem.vue'),
          },
          {
            name: 'payrolls',
            path: 'payrolls',
            component: () => import('../pages/payroll/Payrolls.vue'),
          },
          {
            name: 'view-payroll',
            path: 'view/:id',
            component: () => import('../pages/payroll/ViewPayroll.vue'),
          },
          // {
          //   name: 'view-invoice',
          //   path: 'view/:id',
          //   component: () => import('../pages/invoices/InvoicePage.vue'),
          // },
          // {
          //   name: 'new-invoice',
          //   path: 'new',
          //   component: () => import('../pages/invoices/NewInvoicePage.vue'),
          // },
        ],
      },
      {
        name: 'clients',
        path: '/clients',
        children: [
          {
            name: 'clients-list',
            path: 'clients-list',
            component: () => import('../pages/clients/Clients.vue'),
          },
          {
            name: 'view-client',
            path: 'view/:id',
            component: () => import('../pages/clients/ClientPage.vue'),
          },
        ],
      },
      {
        name: 'projects',
        path: '/projects',
        children: [
          {
            name: 'projects-list',
            path: 'projects-list',
            component: () => import('../pages/projects/ProjectsPage.vue'),
          },
          {
            name: 'view-project',
            path: 'view/:id',
            component: () => import('../pages/projects/ProjectPage.vue'),
          },
        ],
      },
      {
        name: 'payments',
        path: '/payments',
        children: [
          {
            name: 'payments-list',
            path: 'payments-list',
            component: () => import('../pages/new_payments/NewPaymentsPage.vue'),
          },
          {
            name: 'payment-sources',
            path: 'payment-sources',
            component: () => import('../pages/new_payments/PaymentSourcesPage.vue'),
          },
        ],
      },
      {
        name: 'tasks',
        path: '/tasks',
        children: [
          {
            name: 'tasks-list',
            path: 'tasks-list',
            component: () => import('../pages/tasks/Tasks.vue'),
          },
          {
            name: 'view-task',
            path: 'view/:id',
            component: () => import('../pages/tasks/Task.vue'),
          },
          // {
          //   name: 'payment-sources',
          //   path: 'payment-sources',
          //   component: () => import('../pages/new_payments/PaymentSourcesPage.vue'),
          // },
        ],
      },
      {
        name: 'old-payments',
        path: '/old-payments',
        component: RouteViewComponent,
        children: [
          {
            name: 'old-payment-methods',
            path: 'payment-methods',
            component: () => import('../pages/payments/PaymentsPage.vue'),
          },
          {
            name: 'billing',
            path: 'billing',
            component: () => import('../pages/billing/BillingPage.vue'),
          },
          {
            name: 'pricing-plans',
            path: 'pricing-plans',
            component: () => import('../pages/pricing-plans/PricingPlans.vue'),
          },
        ],
      },
      {
        name: 'faq',
        path: '/faq',
        component: () => import('../pages/faq/FaqPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
